import React from 'react'
import './awardcard.css'
import {
  contentfulImageSrcSet,
  contentfulImageUrl,
} from '../../../lib/contentful-image'

// Keep complete words together without changing the Contentful name.
const titleWords =
  /(“[^”]+”|数学建模|创新创业|同济大学|北京大学|奖学金|毕业设计|毕业生|志愿者|大学生|研究生|青马工程|培养工程|优秀学员|骨干培训|追求卓越|优秀学生|社会实践|社会活动|移动应用|创新赛|英语演讲|朋辈教育|停课不停学|居家健身|小导师|学堂|创新|论坛|歌会|辩论赛|游泳|比赛|大赛|竞赛|项目|沙龙)/g
const renderTitle = (name) =>
  name.split(titleWords).map((part, index) =>
    index % 2 ? (
      <span className="AwardNameWord" key={index}>
        {part}
      </span>
    ) : (
      part
    )
  )

const AwardCard = (props) => (
  <div className="AwardCard">
    <img
      src={contentfulImageUrl(props.certificate, 640)}
      srcSet={contentfulImageSrcSet(props.certificate, [320, 480, 640, 960])}
      sizes={props.sizes || '(max-width: 640px) 45vw, 30vw'}
      draggable="false"
      loading={props.loading || 'lazy'}
      decoding="async"
      alt=""
    />
    <h2>
      {props.balancedTitle ? (
        <span className="AwardName">{renderTitle(props.name)}</span>
      ) : (
        props.name
      )}
    </h2>
    <div className="appidx-info">
      <p>{props.prize}</p>
      <div className="Time">{props.time}</div>
    </div>
  </div>
)

export default AwardCard
